import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ImageUploadField } from "@/components/admin/ImageUploadField";
import { toast } from "sonner";

export function HomeContentManager() {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/content/home").then((res) => setContent(res.data)); }, []);

  if (!content) return <p className="text-muted-foreground text-sm">Loading…</p>;

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content/home", content);
      toast.success("Home page updated.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to save.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="home-content-manager" className="bg-background border border-border p-6 space-y-6 max-w-lg">
      <div>
        <Label>Hero Image</Label>
        <p className="text-xs text-muted-foreground mb-2">The large photo shown on the Home page hero section.</p>
        <ImageUploadField testId="home-form-hero-image-input" value={content.hero_image} onChange={(v) => setContent({ ...content, hero_image: v })} />
      </div>
      <p className="text-xs text-muted-foreground">
        The three program preview images below are managed from the "Programs Page" tab and automatically reflect here too.
      </p>
      <Button onClick={handleSave} disabled={saving} data-testid="home-content-save-button" className="w-full rounded-none bg-accent text-accent-foreground">
        {saving ? "Saving…" : "Save Home Page"}
      </Button>
    </div>
  );
}
